/*
 * config.enum.eSystem.ts
 *
 */
export enum eTypeCRUDOps {
  eNOOPS = 'eNOOPS',
  //
  // eCREATE = 'eCREATE',
  // eREAD = 'eREAD',
  // eUPDATE = 'eUPDATE',
  // eDELETE = 'eDELETE',
  // 20250107: Change to facilitate UX display
  eCREATE = 'CREATE',
  eREAD = 'READ',
  eUPDATE = 'UPDATE',
  eDELETE = 'DELETE',
  // 20260702: Remove 'e' from 'eVIEW'!
  eVIEW = 'VIEW',
}
//
export enum eTypeVOAO {
  eUNDEFINED = 'eUNDEFINED',
  eVO = 'VO',
  eAO = 'AO',
}
//
export enum eUserOpsUpdateFrom {
  eUndefined = 'eUndefined',
  eAdminUser = 'eAdminUser',
  eAdminHRUser = 'eAdminHRUser',
}
//
export enum ePSTrainerWeekendDutyLocation {
  eUNDEFINED = 'UNDEFINED!',
  eKBC = 'KBC',
  eKJC = 'KJC',
  eSBC = 'SBC',
  eSDC = 'SDC',
}
//#end#
